import React, { Component } from 'react';
import { func } from 'prop-types';

import UTList from 'app/components/UTList';
import { accountPropTypes } from 'redux/accountHandlers';

import styles from './styles';

export default class AccountsMobileTable extends Component {
  onEndReached = () => this.props.onRowsRendered({ stopIndex: 0 }, true);

  formatAccount = account => ({
    id: account.id,
    title: account.address,
    subtitle: account.holder_name
  });

  render() {
    const formattedAccounts = this.props.accounts.map(this.formatAccount);

    return (
      <UTList
        style={styles.container}
        list={formattedAccounts}
        onClick={this.props.onClick}
        onEndReached={this.onEndReached}
      />
    );
  }
}

AccountsMobileTable.propTypes = {
  accounts: accountPropTypes,
  onClick: func,
  onRowsRendered: func
};
